import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submission26',
  templateUrl: './submission.component.html',
  styleUrls: ['./submission.component.css']
})
export class SubmissionComponent26 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
